import { CardNumberElement } from "@stripe/react-stripe-js";
import showToaster from "../../../helpers/toasterMessages/showToaster";
import { makeServicePlanPaymentAction, makeServicePlanReturnPaymentAction, processCardAction } from "../../../actions/ServicePlans/makeServicePlanPayment/makeServicePlanPayment";

async function submit(values, dispatch, props) {
    const { stripe, elements } = props;

    let message = "", paymentMethodId, createPaymentMethod;

    if (props?.isCancel) {
        await dispatch(makeServicePlanReturnPaymentAction(values));
        return
    }

    if (values?.paymentType === "2") {
        if (!stripe || !elements) return;

        const card = elements.getElement(CardNumberElement);
        if (!card) return;

        createPaymentMethod = await stripe.createPaymentMethod({
            type: "card",
            card,
            billing_details: {
                address: {
                    postal_code: values?.zipcode
                }
            }
        });

        if (createPaymentMethod?.paymentMethod) {
            paymentMethodId = createPaymentMethod.paymentMethod.id;
        }
    }

    if (createPaymentMethod?.error?.message && values?.paymentType === "2") {
        message = createPaymentMethod?.error?.message;
        showToaster({
            messageId: "commonError",
            toasterType: "error",
            requestMessage: message
        });
        return;
    }

    if (Number(values?.paymentType) === 2 && !values.zipcode) {
        showToaster({
            messageId: "inCompleteZipCode",
            toasterType: "error"
        });
        return;
    }

    const { status, paymentIntentSecret, purchaseServicePlanData } = await dispatch(makeServicePlanPaymentAction(values, paymentMethodId));


    if (status == 400 && Number(values?.paymentType) === 2) {
        const cardAction = await stripe.handleCardAction(
            paymentIntentSecret,
        );
        let amount = purchaseServicePlanData?.price, userType = purchaseServicePlanData?.userType;
        let confirmPaymentIntentId;

        if (cardAction?.paymentIntent && cardAction?.paymentIntent?.id) {
            confirmPaymentIntentId = cardAction?.paymentIntent?.id;

            const { handleCardActionStatus, errorMessage } = await dispatch(processCardAction(
                {
                    servicePlanId: purchaseServicePlanData?.id,
                    userId: purchaseServicePlanData?.userId,
                    confirmPaymentIntentId,
                    amount,
                    userType,
                    listId: purchaseServicePlanData?.listId
                }
            ));

        } else {
            if (cardAction?.error && cardAction?.error?.message) {
                let msg = cardAction?.error?.message;
                showToaster({ messageId: 'commonError', toasterType: 'error', requestMessage: msg })
            }
        }
    }
}

export default submit;
